import './GenericErrorModal.scss'

import React, { Fragment } from 'react'

import Button from '../../components/Button/Button'
import Modal from '../../components/Modal/Modal'
import ModalContent from '../../components/Modal/ModalContent'
import { closeEvent } from '../../components/Modal/ModalEvents'
import t from '../../helpers/i18n'

const HANDLED_ERRORS = {
  'VALIDATION_FAILURE': true,
  'INTERNAL_SERVER_ERROR': true,
  'NOT_FOUND': true,
  'NOT_AUTHENTICATED': true,
  'INVALID_RESPONSE': true
}

const GenericErrorModal = ({ error, i18nPrefix, onCloseRequested }) => {

  return (
    <Modal onCloseRequested={onCloseRequested}>
      <ModalContent dialog>
        <div className="generic-error-modal">
          {error.code === "VALIDATION_FAILURE" &&
            <Fragment>
              <div className="-title label-default-medium">{t('validations.Validation_error')}</div>
              <div className="-description caption-small-basic">{t('validations.It_seems_a_problem_has_occurred_during_the_processing')}</div>
              <div className="-list">
                {Object.keys(error.data).map(key => (
                  <div key={key} className="-item">
                    <div className="-field caption-small-basic">{t(`${i18nPrefix}.${key}`)}</div>
                    <div className="-message caption-small-basic">{error.data[key].message || t('validations.Invalid')}</div>
                    <div className="-code caption-tiny-basic">({error.data[key].code})</div>
                  </div>
                ))}
              </div>
            </Fragment>
          }
          {error.code === 'INTERNAL_SERVER_ERROR' &&
            <Fragment>
              <div className="-title label-default-medium">{t('validations.Internal_Server_Error')}</div>
              <div className="-description caption-small-basic">{t('validations.An_unknown_error_occurred')}</div>
            </Fragment>
          }
          {error.code === 'INVALID_RESPONSE' &&
            <Fragment>
              <div className="-title label-default-medium">{t('validations.Internal_Server_Error')}</div>
              <div className="-description caption-small-basic">{t('validations.The_server_did_not_respond')} </div>
            </Fragment>
          }
          {error.code === 'NOT_FOUND' &&
            <Fragment>
              <div className="-title label-default-medium">{t('validations.Page_not_found')}</div>
              <div className="-description caption-small-basic">{t('validations.The_requested_page_does_not_exists')}</div>
            </Fragment>
          }
          {error.code === 'NOT_AUTHENTICATED' &&
            <Fragment>
              <div className="-title label-default-medium">{t('validations.Authentication_error')}</div>
              <div className="-description caption-small-basic">{t('validatios.not_authenticated')}</div>
            </Fragment>
          }
          {!HANDLED_ERRORS[error.code] &&
            <Fragment>
              <div className="-title label-default-medium">{t('validations.Unknown_error')}</div>
              <div className="-description caption-small-basic">{t('validations.Please_contact_the_administrator')}</div>
              <div className="-list">
                <div className="-item">
                  <div className="-field caption-small-basic">{t('validations.Error')}</div>
                  <div className="-code caption-tiny-basic">{JSON.stringify(error)}</div>
                </div>
              </div>
            </Fragment>
          }
          <div className="-buttons">
            <Button onClick={event => closeEvent(event.currentTarget, false)} label={t("Dismiss")} />
          </div>
        </div>
      </ModalContent>
    </Modal>
  )
}

export default GenericErrorModal